export const PersonSvg = () => {
  return (
    <svg
      width='40'
      height='40'
      viewBox='0 0 40 40'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_2134_5078)'>
        <g clipPath='url(#clip1_2134_5078)'>
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M6.72258 5.91292C8.07158 5.31239 9.52574 5 11 5C12.4744 5 13.9285 5.31239 15.2775 5.91292C16.6258 6.51314 17.837 7.38668 18.8478 8.47311C19.4644 9.13581 20.5356 9.13581 21.1522 8.47311C23.1958 6.27679 26.0136 5.00002 29 5.00002C31.9864 5.00002 34.8042 6.27679 36.8478 8.47311C38.8854 10.6629 40 13.5945 40 16.6151C40 19.6358 38.8854 22.5674 36.8478 24.7571L24.4514 38.0798C22.0692 40.6401 17.9308 40.6401 15.5486 38.0798L3.15226 24.7571C2.14172 23.6712 1.34948 22.3922 0.81204 20.9978C0.27462 19.6034 0 18.1147 0 16.6151C0 15.1156 0.27462 13.6269 0.81204 12.2325C1.34948 10.8381 2.14172 9.55914 3.15226 8.47311C4.16314 7.38668 5.37432 6.51314 6.72258 5.91292Z'
            fill='#273BCD'
          />
        </g>
      </g>
      <defs>
        <clipPath id='clip0_2134_5078'>
          <rect width='40' height='40' fill='white' />
        </clipPath>
        <clipPath id='clip1_2134_5078'>
          <rect width='40' height='40' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}
